'use client';
import { Alert, Box } from '@mui/material';
import { useParams } from 'next/navigation';
import ChapterNote from '@/components/course/chapter-note';
import CourseContent from '@/components/course/course-content';
import AppLayout from '@/components/layout/app-layout';
import LoadingIndicator from '@/components/shared/loading-indicator';
import { useAuth, useCourses } from '@/providers';
import { useViewStore } from '@/stores';

export default function Page() {
  const { chapterSlug } = useParams() as { chapterSlug?: string };
  const { selectedChapter, selectedCourse, isLoading, chapterLoadError } = useCourses();
  const { isLoggedIn } = useAuth();
  const { showChapterNote } = useViewStore();

  const chapterInCurriculum = selectedCourse?.curriculum.some(
    ({ item }) => item.slug === chapterSlug,
  );

  if (isLoading) {
    return (
      <AppLayout>
        <LoadingIndicator label="Kursinhalte werden geladen..." />
      </AppLayout>
    );
  }

  if (chapterLoadError && chapterInCurriculum) {
    return (
      <AppLayout>
        <Alert severity="error" sx={{ m: 2 }}>
          Dieses Kapitel konnte nicht geladen werden. Bitte lade die Seite neu oder kontaktiere den
          Support, wenn das Problem bestehen bleibt.
        </Alert>
      </AppLayout>
    );
  }

  if (!selectedChapter) {
    return (
      <AppLayout>
        <Alert severity="error" sx={{ m: 2 }}>
          Kapitel konnte nicht gefunden werden.
        </Alert>
      </AppLayout>
    );
  }

  const { id, type } = selectedChapter;
  const showNotes = isLoggedIn && showChapterNote && selectedChapter && type !== 'Exercise';

  return (
    <AppLayout container={false}>
      <Box sx={{ width: '100%', position: 'relative' }}>
        <Box
          sx={{
            width: '100%',
            ...(showNotes
              ? {
                  pl: { md: '24px' },
                  pr: { md: '50vw' },
                }
              : {
                  maxWidth: (theme) => theme.breakpoints.values.lg,
                  mx: 'auto',
                }),
          }}>
          <CourseContent />
        </Box>
        {showNotes && <ChapterNote chapterId={id} chapterType={type} />}
      </Box>
    </AppLayout>
  );
}
